<template>
  <layout-main-inner title="监管部门">
    <div
      v-if="permission.LVL2"
      slot="action">
      <el-button
        type="primary"
        @click="additem">
        新增账号
      </el-button>
      <!-- <el-dropdown>
        <el-button
          type="primary"
          style="margin-left: 10px;">
          更多<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="additem({},2)">新增员工账号</el-dropdown-item>
  <el-dropdown-item @click.native="()=> {additem({},2)}">新增普通账号</el-dropdown-item>
       </el-dropdown-menu>
      </el-dropdown> -->
    </div>
    <layout-card-wrap>
      <!-- <template slot="form">
        <el-input
          v-model="config.quarantineName"
          clearable
          placeholder="请输入分类名称"
          @clear="handleCurrentChange(1)"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template> -->
      <el-table
        border
        :data="list">
        <el-table-column
          label="账号"
          prop="account"> </el-table-column>
        <el-table-column
          label="姓名"
          prop="staffName"> </el-table-column>
        <el-table-column
          label="手机号"
          prop="mobile"> </el-table-column>
        <el-table-column
          label="功能"
          min-width="300">
          <template slot-scope="{ row }">
            <!-- <div
              v-for="item in row.functions"
              :key="item.funcId">
              {{ item.funcName }}
            </div> -->
            {{ row.functionsStr }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="permission.LVL2"
          label="操作"
          width="145">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.isAdmin !== 1"
              type="info"
              @click="updateitem(row)"
            >
              编辑
            </el-button>
            <el-button
              v-if="row.isAdmin !== 1"
              type="danger"
              @click="deleteitem(row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </layout-card-wrap>
    <edit-user-modal
      ref="user"
      :callback="
        () => {
          getlist();
        }
      "
    />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import EditUserModal from './edit-user-modal.vue'

export default {
  name: 'CategorysIndex',
  components: { EditUserModal },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        operTypes: [1]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    updateitem(row) {
      const operations = {}
      const functions = row.functions || []
      functions.forEach((i) => {
        operations[i.funcId] = i.operations.map(s => s.operation)
      })
      this.$refs.user.update({
        staffId: row.staffId,
        staffName: row.staffName,
        account: row.account,
        servicePermmisions: (row.servicePermmisions || []).map(
          (i) => i.serviceId
        ),
        functions: row.functions.map((i) => i.funcId),
        mobile: row.mobile,
        operations
      })
    },
    additem(row = {}) {
      this.$refs.user.add(row)
    },
    deleteitem(row) {
      this.$confirm('您确定删除该账号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deletestaff', {
          payload: {
            staffId: row.staffId
          },
          success: () => {
            this.loading = false
            this.getlist()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getstaffs', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            return {
              ...i,
              functionsStr: i.functions.map(s => s.funcName).join('，'),
              servicePermmisionsStr: i.servicePermmisions.map(s => s.serviceName).join('，')
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
